import { render, staticRenderFns } from "./VoiceAnsweredNotice.vue?vue&type=template&id=0ef86048&scoped=true"
import script from "./VoiceAnsweredNotice.vue?vue&type=script&lang=js"
export * from "./VoiceAnsweredNotice.vue?vue&type=script&lang=js"
import style0 from "./VoiceAnsweredNotice.vue?vue&type=style&index=0&id=0ef86048&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef86048",
  null
  
)

export default component.exports